import dynamic from 'next/dynamic';
const CenteredCarousel = dynamic(() => import('./CenteredCarousel'));
export default CenteredCarousel;
